import React, { useMemo } from 'react';

import { useIntSearchParam } from '../../../hooks';

interface Props {
  total: number;
  next: () => void;
  previous: () => void;
}

export default function Navigation(props: Props) {
  const { total, next, previous } = props;

  const [defaultPage] = useIntSearchParam('page');
  const [defaultPageSize] = useIntSearchParam('pageSize');

  const [page, , start, end, limit] = useMemo(() => {
    const memoPage = defaultPage ?? 1;
    const memoPageSize = defaultPageSize ?? 30;
    const memoLimit = memoPage * memoPageSize;
    const memoStart = (memoPage - 1) * memoPageSize + 1;
    const memoEnd = Math.min(total, memoLimit);

    return [memoPage, memoPageSize, memoStart, memoEnd, memoLimit];
  }, [defaultPage, defaultPageSize, total]);

  return (
    <div className="level">
      <div className="level-left">
        {page > 1 && (
          <div className="level-item">
            <button className="button" onClick={previous}>
              Previous
            </button>
          </div>
        )}
      </div>
      <div className="level-item">
        <p>
          Showing {start} - {end} out of {total} products.
        </p>
      </div>
      <div className="level-right">
        {limit < total && (
          <div className="level-item">
            <button className="button" onClick={next}>
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
